<script>
    import { Route, Router } from 'yrv'
    import SchedulesContainer from './v3/schedules-container.svelte'
    import { onMount } from 'svelte'

    let loaded = false
    onMount(() => {
        loaded = true
    })
</script>

{#if loaded}
    <div class="root-content">
        <!-- <div class="tab h-mobile">
            <div class="inside">
                <Link class="link" href="/agenda/all"><Fa icon={faCalendarCheck} /> Agenda</Link>
                <Link class="link" href="/agenda/automacoes"><Fa icon={faRobot} /> Automações</Link>
                <div class="spacer" />
            </div>
        </div> -->

        <Router>
            <Route path="/all">
                <SchedulesContainer />
            </Route>
            <Route path="/automacoes">
                <div class="p-3 text-center">
                    Este recurso mudou para a aba <b>Automações</b>
                </div>
            </Route>
        </Router>
    </div>
{/if}

<style>
    .root-content {
        height: 100%;
        display: flex;
        flex-direction: column;
        padding: 0px;
    }
    @media (max-width: 900px) {
        .root-content {
            padding: 0px;
            padding-top: 0px;
        }
    }
</style>
